<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/purchaselistSh',title:'订单管理'},{title:'采购订单详情'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form
                            :model="zy"
                            label-position="right"
                            ref="zy"
                            :rules="rules"
                            :inline="true"
                            class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>基本信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan1">
                                            <el-form-item label="采购订单号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.code" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="关联销售订单号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.orderCode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="供应商名称" class="h-elformWrap-2">
                                                <el-input  v-model="zy.suserName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item v-if="fkshow" label="付款条件" class="h-elformWrap-2">
                                                <el-input  v-model="zy.dj" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                                <el-input  v-model="zy.cdate" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="期望到货时间" class="h-elformWrap-2">
                                                <el-input  v-model="zy.expectDate" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                        <!-- 附件 -->
                                        <div class="h-formLine dingdan1" v-if="this.orderType == '1'">
                                            <el-form-item label="方案图纸" class="h-elformWrap-2" v-if="this.lkFlag">
                                                <brupload
                                                        :refid=ywid
                                                        reftype="施工图纸"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="施工确认单" class="h-elformWrap-2" v-if="this.lkFlag">
                                                <brupload
                                                        :refid=ywid
                                                        reftype="NX_SGQRD"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                            <el-form-item label="海尔标准配置" class="h-elformWrap-2" v-if="this.lkFlag">
                                                <brselect clearable category="haier_standard" :v="zy.isStandard" disabled="true"
                                                          v-model="order.isStandard"></brselect>
                                            </el-form-item>
                                            <el-form-item label="投标参数" class="h-elformWrap-2" v-if="this.lkFlag ">
                                                <brupload
                                                        :refid=ywid
                                                        reftype="NX_TBCS"
                                                        :showtime="false"
                                                >
                                                </brupload>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>产品信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <el-table
                                                ref="multipleTable"
                                                :data="productlist1"
                                                stripe
                                                border
                                                style="width: 100%">
                                                <el-table-column
                                                        prop="productCateName"
                                                        label="产品大类"
                                                        :show-overflow-tooltip="true"
                                                        min-width="100">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="productDes"
                                                        label="产品型号"
                                                        min-width="120">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="unitPrice"
                                                        label="产品单价"
                                                        min-width="120">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="count"
                                                        label="产品数量"
                                                        min-width="120">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="totalPrice"
                                                        label="订单总价"
                                                        min-width="120">
                                                </el-table-column>
                                                <el-table-column
                                                        prop="zhifakufa"
                                                        label="直发/库发"
                                                        min-width="120">
                                                         <template slot-scope="scope">
                                                        <!-- <div style="text-align: right;">
                                                            {{scope.row.ycountry}}
                                                        </div> -->
                                                        <brselect :disabled="true" category="zhifa_or_kufa" :v="scope.row.zhifakufa"
                                                          :showcode="true"
                                                          v-model="scope.row.zhifakufa"></brselect>
                                                    </template>
                                                </el-table-column>               
                                                <el-table-column
                                                        prop="ycountry"
                                                        label="国家名称"
                                                        min-width="120">
                                                        <template slot-scope="scope">
                                                        <!-- <div style="text-align: right;">
                                                            {{scope.row.ycountry}}
                                                        </div> -->
                                                        <brselect :disabled="true" category="YLCountry_agent" :v="zy.ycountry"
                                                          :showcode="true"
                                                          v-model="zy.ycountry"></brselect>
                                                    </template>
                                                        
                                                </el-table-column>
                                                <el-table-column
                                                        prop="ycuname"
                                                        label="预测人"
                                                        min-width="120"
                                                        :show-overflow-tooltip="true" >
                                                    <template slot-scope="scope">
                                                        {{ scope.row.ycrname }} {{ scope.row.ycrcode }}
                                                    </template>
                                                </el-table-column>
                                                <el-table-column
                                                        prop="ycId"
                                                        label="预测单编号"
                                                        min-width="110">
                                                </el-table-column>
                                                
                                                <el-table-column
                                                        prop="yremark"
                                                        label="备注"
                                                        :show-overflow-tooltip="true"
                                                        width="110"
                                                >
                                                    <template slot-scope="scope">
                                                        <div style="text-align: right;">
                                                            {{scope.row.yremark}}
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                        </el-table>
                                        <!--
                                        <div class="h-formLine dingdan1">
                                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                                <el-input  v-model="zy.productCateName" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.productDes" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品单价" class="h-elformWrap-2">
                                                <el-input  v-model="zy.unitPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品数量" class="h-elformWrap-2">
                                                <el-input  v-model="zy.count" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="订单总价" class="h-elformWrap-2">
                                                <el-input  v-model="zy.totalPrice" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="直发/库发" v-if="zy.type == '3'" class="h-elformWrap-2">
                                                <el-input  v-model="zhifakufa" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="国家名称" class="h-elformWrap-2">
                                                <brselect :disabled="true" category="YLCountry_agent" :v="zy.ycountry"
                                                          :showcode="true"
                                                          v-model="zy.ycountry"></brselect>
                                            </el-form-item>
                                            <el-form-item label="预测人" class="h-elformWrap-2">
                                                <el-input  v-model="zy.ycuname" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="预测单编号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.ycId" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="备注" class="h-elformWrap-2">
                                                <el-input  v-model="zy.yremark" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                        -->
                                    </div>
                                </div>
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>物流信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan1">
                                            <el-form-item label="物流类型" class="h-elformWrap-2">
                                                <!--<dictname v-bind="" category="waybill_type"  :v="zy.waybillType"/>-->
                                                <el-input  v-model="zy.waybillTypeName" readonly> </el-input>
                                             </el-form-item>
                                            <el-form-item label="采购组" class="h-elformWrap-2">
                                                <mdmselect :showcode="true" :disabled="true" category="YLPurchaseGroup" :v="zy.cgGroupCode"
                                                           v-model="zy.cgGroupCode"></mdmselect>
                                            </el-form-item>
                                            <el-form-item label="采购组织" class="h-elformWrap-2">
                                                <brselect :disabled="true" category="purchase_org_code" :v="zy.purchaseOrgCode"
                                                          v-model="zy.purchaseOrgCode"></brselect>
                                            </el-form-item>
                                            <el-form-item label="接收人" class="h-elformWrap-2">
                                                <el-input  v-model="zy.receiver" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="接收人手机号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.receverPhone" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货单位" class="h-elformWrap-2">
                                                <el-input  v-model="zy.receiveUnit" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="收货地址" class="h-elformWrap-2">
                                                <el-input  v-model="zy.detailAddress" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                                <div class="h-pieceIn2" v-if="fkshow">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>付款信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine dingdan1">
                                            <el-form-item label="付款状态" class="h-elformWrap-2">
                                                <el-input  v-model="zy.dj" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="付款金额" class="h-elformWrap-2">
                                                <el-input  v-model="zy.shdw" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="质保金" class="h-elformWrap-2">
                                                <el-input  v-model="zy.shdz" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="付款时间" class="h-elformWrap-2">
                                                <el-input  v-model="zy.jsr" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="付款单号" class="h-elformWrap-2">
                                                <el-input  v-model="zy.jsrsjh" readonly></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="cancel">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data() {
            return {
                ywid:'',
                orderType:'',
                order:true,
                order1:false,
                //带线表单
                value: false,
                cgId: this.$route.query.cgId,
                zhifakufa:null,
                zy: {},
                rules: {
                    formCon4: [
                        {required: true, message: '请输入客户全称', trigger: 'blur'}
                    ],
                    euName: [
                        {required: true, message: '请选择需求分类', trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请输入需求说明', trigger: 'blur'}
                    ]
                },
                //产品list
                productlist1:[],
                fh:{
                    machineCode:"",
                    waybillId:"",
                    waybillName:"",
                    waybillDate:"",
                    cgId:this.$route.query.cgIdStr,
                    code:"",
                    type:"",
                    zhubiaoid:this.$route.query.zhubiaoid,
                    instid:this.$route.query.instid,
                },
                fkshow:false,
                lkFlag:false,
                csFlag:false,
            }
        },
        methods: {
            cancel() {
                this.$router.go(-1);
            }
        },
        beforeRouteLeave(to,from,next){
            to.meta.keepAlive = true;
            next();
        },
        mounted() {
            if (this.cgId != null) {
                
                //查看订单详情
                ss.orderCgService.selectOrderListByInstid(this.fh).then(rd => {
                    //初始化默认数据
                    this.productlist1 = rd.obj
                    this.zy = this.productlist1[0]
                    this.zhifakufa = this.$store.getters.dictname('zhifa_or_kufa',this.zy.zhifakufa);
                    this.ywid = rd.obj.orderId
                    this.orderType = rd.obj[0].orderType
                    console.log(this.orderType)
                    //判断是否冷库
                    ss.waixiao.isLk(rd.obj.productNo).then(rd => {
                        this.lkFlag = rd.msg;
                        console.log("lkFlag",this.lkFlag)
                    })
                    //判断是否海尔标准配置
                    if(rd.obj.orderCode){
                        var data = rd.obj.orderCode;
                        ss.OrderMainService.checkStandard(data).then(rd => {
                            if(rd.msg == 1){
                                this.zy.isStandard = rd.msg;
                            }else if(rd.msg == 2){
                                this.zy.isStandard = rd.msg;
                                this.csFlag = true;
                            }
                        })
                    }
                })
            }
        }

    }
</script>
<style>
    .dingdan1.h-formLine .el-form-item__label {
        width: 35%;
        text-align: right;
    }
    .dingdan1.h-formLine .el-form-item__content {
        width: 65%;
    }
    .dingdan1.h-formLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }
    .dingdan1.h-formLine .h-elformWrap-4 {
        width: 66%;
        padding-right: 0.5rem
    }
    .dingdan1.h-formLine .h-elformWrap-4 .el-form-item__label {
        width: 17%;
        text-align: right;
    }
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 0.6rem;
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;;
	}
</style>
